/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Smflashcardsbody2Inputs */

const zh_landing_admin_smflashcardsbody2 = /** @type {(inputs: Landing_Admin_Smflashcardsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主动回忆，间隔重复`)
};

const en_landing_admin_smflashcardsbody2 = /** @type {(inputs: Landing_Admin_Smflashcardsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active recall, spaced`)
};

const es_landing_admin_smflashcardsbody2 = /** @type {(inputs: Landing_Admin_Smflashcardsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuerdo activo, espaciado`)
};

/**
* | output |
* | --- |
* | "Active recall, spaced" |
*
* @param {Landing_Admin_Smflashcardsbody2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_smflashcardsbody2 = /** @type {((inputs?: Landing_Admin_Smflashcardsbody2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Smflashcardsbody2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_smflashcardsbody2(inputs)
	if (locale === "en") return en_landing_admin_smflashcardsbody2(inputs)
	return es_landing_admin_smflashcardsbody2(inputs)
});
export { landing_admin_smflashcardsbody2 as "landing_admin_smFlashcardsBody" }